import { ApolloLink, Operation } from "@apollo/client";

import { environment } from "../../environments/environment";
import { getServiceBaseUrl } from "../../utils/getServiceBaseUrl";

export const getAuthLink = () =>
  new ApolloLink((operation: Operation, forward) => {
    operation.setContext(({ headers = {} }) => {
      const serviceBaseUrl = getServiceBaseUrl(operation);

      // return the headers to the context so httpLink can read them
      return {
        headers: {
          ...headers,
        },
        uri: `${serviceBaseUrl}${environment.basePath}`,
      };
    });

    return forward(operation);
  });
